import { useState } from "react";
import { motion } from "framer-motion";
import Sparkline from "./Sparkline";
import { usePrice } from "../hooks/usePrice";
import { CHART_EMBED_URL } from "../lib/constants";

const TABS = [
  { k: "waves", label: "Wave View" },
  { k: "dex", label: "DexScreener" },
];

export default function ChartTabs() {
  const [view, setView] = useState("waves");
  const { data, isLoading } = usePrice();
  const ok = data?.ok;

  return (
    <motion.div
      initial={{ y: 36, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      viewport={{ once: true, amount: 0.15 }}
      className="sticker-lg mt-10 rounded-3xl bg-white p-2 sm:p-3"
    >
      <div
        data-testid="chart-view-toggle"
        className="flex items-center justify-end gap-2 px-2 pb-2 pt-1.5"
      >
        {TABS.map((t) => (
          <button
            key={t.k}
            data-testid={`chart-tab-${t.k}`}
            onClick={() => setView(t.k)}
            className={`rounded-full border-[3px] border-ocean-navy px-4 py-1.5 font-display text-sm font-semibold transition-all ${
              view === t.k
                ? "bg-ocean-navy text-white shadow-[3px_3px_0_#0F172A]"
                : "bg-white text-ocean-navy hover:bg-ocean-bg2"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {view === "waves" ? (
        <div className="p-1 sm:p-2">
          <Sparkline />
        </div>
      ) : isLoading || !ok ? (
        <div className="flex h-[420px] flex-col items-center justify-center gap-3 rounded-2xl bg-ocean-bg sm:h-[520px]">
          <span className="h-12 w-12 animate-spin rounded-full border-4 border-ocean-sky border-t-transparent" />
          <p className="font-display text-lg font-medium text-ocean-muted">
            The whale is diving for data…
          </p>
        </div>
      ) : (
        <iframe
          data-testid="chart-embed"
          title="$BLUE live chart on DexScreener"
          src={CHART_EMBED_URL}
          className="h-[420px] w-full rounded-2xl border-0 sm:h-[520px]"
          loading="lazy"
        />
      )}
    </motion.div>
  );
}
